var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4495)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4495",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.725037 0.5H32.725V32.5H0.725037V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9188 31.8179C7.18378 31.5322 2.10004 30.239 2.10004 28.6869C2.10004 27.0594 7.68567 25.717 14.9038 25.5206",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5501 25.5205C25.7682 25.7168 31.3538 27.0592 31.3538 28.6867C31.3538 30.239 26.2688 31.5323 19.5325 31.8179",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3501 31.875C17.3501 32.2202 17.0703 32.5 16.725 32.5C16.3799 32.5 16.1 32.2202 16.1 31.875C16.1 31.5299 16.3799 31.2501 16.725 31.2501C17.0703 31.2501 17.3501 31.5299 17.3501 31.875Z",
    fill: "#A7A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7253 28.6851L8.76948 14.9053C7.00155 11.8431 7.22254 8.39816 8.76948 5.71872C10.3164 3.03935 13.1894 1.12547 16.7253 1.12547C20.2613 1.12547 23.1341 3.03935 24.6811 5.71872C26.228 8.39816 26.449 11.8431 24.6811 14.9053L16.7253 28.6851Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7253 17.0258C13.0308 17.0258 10.025 14.02 10.025 10.3255C10.025 6.63096 13.0308 3.62521 16.7253 3.62521C20.4199 3.62521 23.4256 6.63096 23.4256 10.3255C23.4256 14.02 20.4199 17.0258 16.7253 17.0258Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5884 10.8418V11.4503C19.5997 13.0314 18.2756 14.3323 16.7192 14.3194C15.1634 14.3323 13.8392 13.0314 13.8501 11.4503V10.8557",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0295 10.2817C18.0799 10.2451 17.1704 10.0058 16.7179 9.1884C16.2655 10.0057 15.3558 10.2452 14.4063 10.2817C14.0951 10.2937 13.8486 10.5487 13.8487 10.8602C13.731 10.7857 13.5302 10.6323 13.4371 10.3734C13.4371 10.3734 13.4 10.1727 13.4 9.92022C13.4 8.25297 14.8855 6.68184 16.7179 6.68184C18.5503 6.68184 20.0357 8.25297 20.0357 9.92022C20.0357 10.1727 19.9986 10.3735 19.9986 10.3735C19.9056 10.6323 19.7048 10.7857 19.5871 10.8602C19.5871 10.5487 19.3407 10.2937 19.0295 10.2817Z",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 15.8813C13.1263 15.5695 13.3144 15.2888 13.5488 15.0544C14.0013 14.6019 14.6276 14.3213 15.3188 14.3213H18.165C18.8564 14.3213 19.4826 14.6019 19.9351 15.0544C20.1695 15.2888 20.3575 15.5695 20.4837 15.8813",
    stroke: "#A7A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6,
    height: 32,
    fill: "white",
    transform: "translate(0.200012 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocal);
export default __webpack_public_path__ + "static/media/local.fd9f334444883dea2739e6dbc11720ec.svg";
export { ForwardRef as ReactComponent };